import { render, staticRenderFns } from "./InventionApply.vue?vue&type=template&id=74c52061&scoped=true&"
import script from "./InventionApply.vue?vue&type=script&lang=js&"
export * from "./InventionApply.vue?vue&type=script&lang=js&"
import style0 from "./InventionApply.vue?vue&type=style&index=0&id=74c52061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c52061",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VSelect,VTextField})
